/* eslint-disable */
import MainTitle from '../../components/MainTitle'
import { NavLink, useParams } from 'react-router-dom'
import CardButton from '../../components/CardButton'
import useAuth from '../../hooks/useAuth'

import { useState, useEffect } from 'react'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Pagination from '../../components/Pagination'
import {
  faTrashCan,
  faMagnifyingGlass,
  faEye,
  faPlus,
  faSort,
  faSortUp,
  faSortDown,
} from '@fortawesome/free-solid-svg-icons'
import Modal from '../../components/Modal'
import { Link } from 'react-router-dom'
import moment from 'moment'
import { data } from 'autoprefixer'
import UserNav from '../../components/UserNav'

function UserClients() {
  const axios = useAxiosPrivate()
  const { setShowLoader, can, createInfo } = useAuth()

  const [clients, setClients] = useState([])
  const [deleteClient, setDeleteClient] = useState({})
  const [showModal, setShowModal] = useState(false)

  const [search, setSearch] = useState('')

  const [currentRecords, setCurrentRecords] = useState([])
  const [filteredRecords, setFilteredRecords] = useState([])
  const [nPages, setNumberOfPages] = useState(0)

  const [currentPage, setCurrentPage] = useState(1)
  // No of Records to be displayed on each page
  const [recordsPerPage] = useState(10)

  const [indexOfLastRecord, setIndexOfLastRecord] = useState(10)
  const [indexOfFirstRecord, setIndexOfFirstRecord] = useState(0)

  const [modalTitle, setModalTitle] = useState('')

  const [originalRecords, setOriginalRecords] = useState([])
  const [columnClickCounts, setColumnClickCounts] = useState({})
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: 'ascending',
  })

  const [userData, setUserData] = useState({})

  const [risks, setRisks] = useState([])
  const [riskFilter, setRiskFilter] = useState('')
  const [searchFilteredRecordIds, setSearchFilteredRecordIds] = useState([])
  const [riskFilteredRecordIds, setRiskFilteredRecordIds] = useState([])
  const [searchFilter, setSearchFilter] = useState('')

  const { id } = useParams()

  useEffect(() => {
    getUserById(id)
    fetchRisks()
  }, [id])

  const getUserById = async () => {
    try {
      setShowLoader(true)
      const response = await axios.get(`/users/${id}`)
      if (response.data.result) {
        setUserData(response.data.result)
        getClients(response.data.result.id)
      } else {
        navigate(from, { replace: true })
      }
      setShowLoader(false)
    } catch (error) {
      setShowLoader(false)
    }
  }

  const sortArray = (array, key, direction) => {
    return [...array].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'ascending' ? -1 : 1
      if (a[key] > b[key]) return direction === 'ascending' ? 1 : -1
      return 0
    })
  }

  const renderSortArrow = (columnKey) => {
    if (sortConfig.key === columnKey) {
      if (sortConfig.direction === 'ascending') {
        return <FontAwesomeIcon icon={faSortUp} />
      } else {
        return <FontAwesomeIcon icon={faSortDown} />
      }
    }
    return <FontAwesomeIcon icon={faSort} />
  }

  const handleSort = (key) => {
    let newColumnClickCounts = { ...columnClickCounts }
    if (!newColumnClickCounts[key]) {
      newColumnClickCounts[key] = 1
    } else {
      newColumnClickCounts[key]++
    }

    if (newColumnClickCounts[key] === 3) {
      setSortConfig({
        key: null,
        direction: 'descending',
      })
      newColumnClickCounts[key] = 0
      setCurrentRecords(
        originalRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      )
    } else {
      let direction =
        sortConfig.direction === 'ascending' ? 'descending' : 'ascending'
      setSortConfig({ key, direction })

      const sortedRecords = sortArray(originalRecords, key, direction)
      setCurrentRecords(
        sortedRecords.slice(indexOfFirstRecord, indexOfLastRecord)
      )
    }
    setColumnClickCounts(newColumnClickCounts)
  }

  const nextPage = () => {
    if (currentPage < nPages) {
      const newPage = currentPage + 1
      const indexFirst = newPage * recordsPerPage - recordsPerPage
      const indexLast = (newPage * recordsPerPage > filteredRecords.length) ? filteredRecords.length : newPage * recordsPerPage;

      setIndexOfFirstRecord(indexFirst)
      setIndexOfLastRecord(indexLast)
      setCurrentPage(newPage)

      const sortedRecords = sortArray(
        originalRecords,
        sortConfig.key,
        sortConfig.direction
      )
      setCurrentRecords(sortedRecords.slice(indexFirst, indexLast))
    }
  }

  const fetchRisks = async () => {
    try {
      const response = await axios.get('/risk-options/all');
      const risks = response.data.result;
      setRisks(risks);
    } catch (error) {
      createInfo('Error fetching risks');
    }
  };


  const previousPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1
      const indexFirst = (newPage - 1) * recordsPerPage
      const indexLast = newPage * recordsPerPage

      setIndexOfFirstRecord(indexFirst)
      setIndexOfLastRecord(indexLast)
      setCurrentPage(newPage)

      const sortedRecords = sortArray(
        originalRecords,
        sortConfig.key,
        sortConfig.direction
      )
      setCurrentRecords(sortedRecords.slice(indexFirst, indexLast))
    }
  }

  const handleSearch = (handle) => {
    setIndexOfFirstRecord(0)
    setIndexOfLastRecord(10)
    setCurrentPage(0)
    setCurrentRecords(filteredRecords.slice(0, 10))

    let searchValue = handle.target.value
    setSearch(searchValue)
    let searchString = searchValue.trim().toLowerCase()
    if (searchString.length > 0) {
      let records = clients.filter((e) => {
        return (
          e.name?.toLowerCase().match(searchString) ||
          e.email?.toLowerCase().match(searchString) ||
          e.reference?.toLowerCase().match(searchString) ||
          e.status?.toLowerCase().match(searchString)
        )
      })
      let ids = []
      records.forEach((record) => {
        ids.push(record.id)
      })
      setSearchFilter(searchString)
      setSearchFilteredRecordIds(ids)
    } else {
      setSearchFilter('')
    }

    setSortConfig({
      key: null,
      direction: 'descending',
    })
  }

  useEffect(() => {
    setCurrentPage(1)
    let curRecords = []
    if (!searchFilter && !riskFilter) {
      curRecords = clients
    } else {
      curRecords = clients.filter((record) => {
        return (
          (!riskFilter || riskFilteredRecordIds.includes(record.id)) && 
          (!searchFilter || searchFilteredRecordIds.includes(record.id)))
      })
    }

    setFilteredRecords(curRecords)
    setCurrentRecords(curRecords.slice(0, 10))
    setIndexOfFirstRecord(0)
    setIndexOfLastRecord((recordsPerPage > curRecords.length) ? curRecords.length : recordsPerPage)
    setNumberOfPages(Math.ceil(curRecords.length / recordsPerPage))
  }, [searchFilter, riskFilter])


  const getClients = async (id) => {
    try {
      const response = await axios.get(`/clients/all/by-user/${id}`)
      setClients(response.data.result)
      setOriginalRecords(response.data.result)
      setFilteredRecords(response.data.result)
      setCurrentRecords(
        response.data.result.slice(indexOfFirstRecord, indexOfLastRecord)
      )
      await setIndexOfLastRecord(response.data.result?.length < 10 ? response.data.result?.length : 10)
      setNumberOfPages(Math.ceil(response.data.result.length / recordsPerPage))
    } catch (error) {}
    setShowLoader(false)
  }

  const handleRiskChange = (e) => {
    const value = e.target.value
    setRiskFilter(value);
    
    const riskFilteredRecords = clients.filter((record) => {
      return record.risk[0]?.id?.toString() === value
    })

    let ids = []
    riskFilteredRecords.forEach((record) => {
      ids.push(record.id)
    })

    setRiskFilteredRecordIds(ids)
  }

  const resetFilters = () => {
    setRiskFilter('');
    setSearchFilter('')
    setFilteredRecords(clients)
    setCurrentRecords(clients.slice(indexOfFirstRecord, indexOfLastRecord))
    setNumberOfPages(Math.ceil(clients.length / recordsPerPage))
  };

  const isFilterApplied = () => {
    return riskFilter !== '' || searchFilter !== '';
  };

  const resetModal = (resetClients = true) => {
    setDeleteClient({})
    setShowModal(false)
    if (resetClients) {
      setClients(clients)
    }
  }

  return (
    <section>
      <MainTitle title="Clients" />

      <UserNav active="clients" userId={userData.id} />

      <div className="py-4 flex justify-between items-center">
        <div className="relative mt-1">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <FontAwesomeIcon icon={faMagnifyingGlass} onClick={handleSearch} />
          </div>
          <input
            type="text"
            id="table-search"
            value={searchFilter}
            onChange={handleSearch}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-80 pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Search Clients"
          />
        </div>
        <div className="py-4">
          <select
            onChange={handleRiskChange}
            value={riskFilter}
            className='px-4 py-2 border border-gray-300 rounded-md shadow-md mr-2'
          >
            
            <option value="">Filter by Risk</option>
            {risks.map((risk, index) => (
              <option key={risk.id} value={risk.id}>
                {risk.title}
              </option>
            ))}
          </select>
          {isFilterApplied() && (
            <button
              onClick={resetFilters}
              className="bg-red-500 text-white rounded-lg px-4 py-2 ml-4"
            >
              Reset Filters
            </button>
          )}
        </div>
      </div>

      <table className="table-main">
        <thead>
          <tr>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('name')}
            >
              Name {renderSortArrow('name')}
            </th>

            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('email')}
            >
              Email {renderSortArrow('email')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('reference')}
            >
              Reference {renderSortArrow('reference')}
            </th>
            <th
              className="cursor-pointer"
              scope="col"
              onClick={() => handleSort('status')}
            >
              Status {renderSortArrow('status')}
            </th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className="table-main">
          {currentRecords.length > 0 ? (
            currentRecords.map((client) => {
              return (
                <tr key={client.id}>
                  <td>{client.name}</td>
                  <td>{client.email}</td>
                  <td>{client.reference}</td>
                  <td>
                    <div
                      className={`status ${client.status
                        .replace(/\s+/g, '-')
                        .toLowerCase()}`}
                    >
                      {client.status}
                    </div>
                  </td>
                  <td>
                    <div className="flex justify-center">
                      <Link to={`/clients/${client.id}`}>
                        <span className="flex justify-center items-center bg-blue-400 rounded-md text-blue-800 h-9 w-12 mx-2  hover:bg-blue-500 cursor-pointer">
                          <FontAwesomeIcon icon={faEye} />
                        </span>
                      </Link>
                    </div>
                  </td>
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={7}>
                <p className="no-records">No clients found</p>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination
        next={nextPage}
        prev={previousPage}
        first={indexOfFirstRecord}
        last={indexOfLastRecord}
        total={filteredRecords.length}
      />
    </section>
  )
}

export default UserClients
